import axios from 'axios'
import Cookie from 'js-cookie'

import { isBrowser } from '@/utils/common'

import type { Review } from './type'

const DEFAULT_LENGTH = 20
const DEFAULT_LANG = 'ko-KR'

async function getReviews(
  target: {
    hospitalId?: number
    eventId?: number
    q?: string
    categoryId?: number
    treatmentId?: number
    doctorId?: number
  },
  pageIndex = 0,
  length = DEFAULT_LENGTH,
  language = DEFAULT_LANG,
  token?: string,
  userIp?: string,
): Promise<{ data: Review[]; isLastPage: boolean; total: number }> {
  const subHeader = userIp ? { 'x-forwarded-for': userIp } : {}
  try {
    const baseURL = isBrowser() ? '/' : 'http://127.0.0.1:3000'

    const result = await axios({
      method: 'get',
      url: `/api/v2/reviews`,
      baseURL,
      params: {
        ...target,
        pageIndex,
        length,
      },
      headers: {
        Authorization: token || Cookie.get('token') || '',
        'Accept-Language': language,
        ...(userIp && { 'x-forwarded-for': userIp }),
      },
    })

    return {
      data: result.data.data,
      total: result.data.pagination?.totalElementNumber || 0,
      isLastPage: result.data.pagination?.isLastPage || false,
    }
  } catch {
    return {
      data: [],
      total: 0,
      isLastPage: false,
    }
  }
}

export async function getReviewsInHospital(
  hospitalId: number,
  pageIndex: number,
  length: number,
  language?: string,
): Promise<{ data: Review[]; isLastPage: boolean; total: number }> {
  return await getReviews({ hospitalId }, pageIndex, length, language)
}

export async function getReviewsInEvent(
  eventId: number,
  pageIndex: number,
  length: number,
  language?: string,
): Promise<{ data: Review[]; isLastPage: boolean; total: number }> {
  return await getReviews({ eventId }, pageIndex, length, language)
}

export async function getSearchedReviews(
  target: {
    q?: string
    categoryId?: number
    treatmentId?: number
  },
  pageIndex: number,
  length: number,
  language?: string,
): Promise<{ data: Review[]; isLastPage: boolean; total: number }> {
  return await getReviews(target, pageIndex, length, language)
}

export async function getReviewsByDoctor(
  doctorId: number,
  pageIndex: number,
  length: number,
  language?: string,
  token?: string,
  userIp?: string,
): Promise<{ data: Review[]; isLastPage: boolean; total: number }> {
  return await getReviews({ doctorId }, pageIndex, length, language, token, userIp)
}
